// Honest reference bar — no fabricated customer counts. Each number is
// verifiable from the product or from public Ohio rule citations.
export const StatBar = () => {
  const stats = [
    { value: "18+", label: "DCY forms pre-built" },
    { value: "5101:2-12", label: "OAC chapters supported" },
    { value: "12", label: "Staff-file checklist items" },
    { value: "24/7", label: "Audit-ready paperwork" },
  ];

  return (
    <section data-testid="stat-bar-section" className="border-y border-stone-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 grid grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-8">
        {stats.map((s, i) => (
          <div key={s.label} data-testid={`stat-${i}`} className="flex flex-col">
            <div className="font-display text-4xl sm:text-5xl font-light text-emerald-800 tracking-tight">
              {s.value}
            </div>
            <div className="mt-2 text-xs uppercase tracking-[0.2em] font-semibold text-stone-500">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatBar;
